export const actionTypes = {
  CUSTOMER_LOGO_URL: 'CUSTOMER_LOGO_URL',
  ACTIVITY_MENU: 'ACTIVITY_MENU',
  SET_AUTH_TOKEN: 'SET_AUTH_TOKEN',
  SET_LOCALE: 'SET_LOCALE',
  DISPLAY_LOADER: 'DISPLAY_LOADER',
  DISPLAY_MESSAGE: 'DISPLAY_MESSAGE',
  SIDE_NAV_CONTENT: 'SIDE_NAV_CONTENT',
  INFO_MESSAGE: 'INFO_MESSAGE',
  PAIR_CODE: 'PAIR_CODE',
  MOBILE_DEVICES: 'MOBILE_DEVICES',
  UPDATE_TRANSLATIONS: 'UPDATE_TRANSLATIONS',
  UPDATE_PRIVACY_POLICY_LINK: 'UPDATE_PRIVACY_POLICY_LINK',
  UPDATE_LANGUAGE_LOCALE: 'UPDATE_LANGUAGE_LOCALE',
  CART_LINK: 'CART_LINK',
  CATALOG_POINTS: 'CATALOG_POINTS',
  CATALOG_SYMBOL: 'CATALOG_SYMBOL',
  BANKS: 'BANKS',
  BANKS_CATALOG: 'BANKS_CATALOG',
  AWARDS: 'AWARDS',
  CATALOGS: 'CATALOGS',
  FOOTERLINKS: 'FOOTERLINKS',
  CATALOG_LINK: 'CATALOG_LINK',
  CLIENT_COLORS: 'CLIENT_COLORS',
  CLAIM_CODE: 'CLAIM_CODE',
  GREETING: 'GREETING',
  BASE_PATH: 'BASE_PATH',
  ALERTS_COUNT: 'ALERTS_COUNT',
  GENERIC_ALERTS: 'GENERIC_ALERTS',
  RECEIVE_ALERTS: 'RECEIVE_ALERTS',
  BANK_ACCOUNT_FILTERS: 'BANK_ACCOUNT_FILTERS',
  BANK_ACCOUNT_TRANSACTIONS: 'BANK_ACCOUNT_TRANSACTIONS',
  BANK_ACCOUNT_PAGINATION: 'BANK_ACCOUNT_PAGINATION',
  SELECT_TAB: 'SELECT_TAB',
  SET_PAGE_VEIW_SIZE: 'SET_PAGE_VEIW_SIZE',
  PAGE_VIEW_NUMBERS: 'PAGE_VIEW_NUMBERS',
  DISPLAY_NO_BANK_TRANSACTIONS: 'DISPLAY_NO_BANK_TRANSACTIONS',
  AVAILABLE_ACCESS_CODE_COUNT: 'AVAILABLE_ACCESS_CODE_COUNT',
  ACTIVE_BANK_ID: 'ACTIVE_BANK_ID',
  OVERVIEW_HISTORY_RECEIVED: 'OVERVIEW_HISTORY_RECEIVED',
  OVERVIEW_HISTORY_SENT: 'OVERVIEW_HISTORY_SENT',
  OVERVIEW_PERSONAL_INFO: 'OVERVIEW_PERSONAL_INFO',
  OVERVIEW_BANK_SUMMARY: 'OVERVIEW_BANK_SUMMARY',
  OVERVIEW_RECENT_ORDERS: 'OVERVIEW_RECENT_ORDERS',
  OVERVIEW_SKILLS_FINDER: 'OVERVIEW_SKILLS_FINDER',
  OVERVIEW_ALERTS: 'OVERVIEW_ALERTS',
  SELECT_BANK: 'SELECT_BANK',
  CUSTOMER_ID: 'CUSTOMER_ID',
  CUSTOMER_DATE_FORMAT: 'CUSTOMER_DATE_FORMAT',
  ORDER_FILTERS: 'ORDER_FILTERS',
  OVERVIEW_PERSONAL_IMAGE: 'OVERVIEW_PERSONAL_IMAGE',
  PRINT_URL: 'PRINT_URL',
  IS_DISPLAY_RECEIVED_ACTIONS: 'IS_DISPLAY_RECEIVED_ACTIONS',
  ORDERS: 'ORDERS',
  ORDERS_PAGINATION: 'ORDERS_PAGINATION',
  SET_ORDERS_PAGE_VEIW_SIZE: 'SET_ORDERS_PAGE_VEIW_SIZE',
  ORDERS_PAGE_VIEW_NUMBERS: 'ORDERS_PAGE_VIEW_NUMBERS',
  IS_DISPLAY_ECARD_DIALOG_ACTIONS: 'IS_DISPLAY_ECARD_DIALOG_ACTIONS',
  IS_DISPLAY_NOMINATION_DIALOG_ACTIONS: 'IS_DISPLAY_NOMINATION_DIALOG_ACTIONS',
  NOMINATION_ACTIVITY_VALUES: 'NOMINATION_ACTIVITY_VALUES',
  ECARD_ACTIVITY_VALUES: 'ECARD_ACTIVITY_VALUES',
  PERSONAL_INFO_VALUES: 'PERSONAL_INFO_VALUES',
  AWARD_DETAIL_VALUES: 'AWARD_DETAIL_VALUES',
  ORDER_DETAIL_VALUES: 'ORDER_DETAIL_VALUES',
  PROGRAMS_DROPDOWN_OPEN: 'PROGRAMS_DROPDOWN_OPEN',
  ORDERS_SEARCH_DISPLAY: 'ORDERS_SEARCH_DISPLAY',
  ORDERS_SEARCH_DATA: 'ORDERS_SEARCH_DATA',
  DOWNLOAD_DROPDOWN_OPEN: 'DOWNLOAD_DROPDOWN_OPEN',
  IS_DISPLAY_BANK_DIALOG_ACTIONS: 'IS_DISPLAY_BANK_DIALOG_ACTIONS',
  IS_DISPLAY_BANK_DETAILS_LINK: 'IS_DISPLAY_BANK_DETAILS_LINK',
  BANK_DETAIL_VALUES: 'BANK_DETAIL_VALUES',
  IS_DISPLAY_PROGRAM_DIALOG_ACTIONS: 'IS_DISPLAY_PROGRAM_DIALOG_ACTIONS',
  PROGRAM_DETAIL_VALUES: 'PROGRAM_DETAIL_VALUES',
  IS_DISPLAY_ALERTS_SECTION: 'IS_DISPLAY_ALERTS_SECTION',
  IS_DISPLAY_SKILLS_SECTION: 'IS_DISPLAY_SKILLS_SECTION',
  IS_DISPLAY_DETAILS_ALERTS: 'IS_DISPLAY_DETAILS_ALERTS',
  PREFFERED_LANGUAGE_LOCALE: 'PREFFERED_LANGUAGE_LOCALE',
  IS_DISPLAY_MESSAGE_DIALOG: 'IS_DISPLAY_MESSAGE_DIALOG',
  HAS_WIDGET_ENABLED: 'HAS_WIDGET_ENABLED',
  PERMISSON_DISPLAY_ITEMS: 'PERMISSON_DISPLAY_ITEMS',
  ORDER_SEARCH: 'ORDER_SEARCH',
  ORDER_SEARCH_PROGRAMS: 'ORDER_SEARCH_PROGRAMS',
  SEARCH_ORDERS_LIST: 'SEARCH_ORDERS_LIST',
  RECENT_RANGE_LIST: 'RECENT_RANGE_LIST',
  IS_RANGE_DROPDOWN_OPEN: 'IS_RANGE_DROPDOWN_OPEN',
  SELECTED_RANGE: 'SELECTED_RANGE',
  RECENT_ORDERS_LIST: 'RECENT_ORDER',
  IS_DISPLAY_REDEEM_LINK: 'IS_DISPLAY_REDEEM_LINK',
  ACTIVE_LANGUAGE: 'ACTIVE_LANGUAGE',
  IS_DISPLAY_SKILLS_LOADER: 'IS_DISPLAY_SKILLS_LOADER',
  IS_LOADING: 'IS_LOADING',
  DISPLAY_SESSION_TIMEOUT: 'DISPLAY_SESSION_TIMEOUT',
  LOGOUT: 'LOGOUT',
  IS_DISPLAY_AWARD_POINTS: 'IS_DISPLAY_AWARD_POINTS',
  IS_DISPLAY_REPLY_LINK: 'IS_DISPLAY_REPLY_LINK',
  IS_DISPLAY_SIDEBAR_PANEL: 'IS_DISPLAY_SIDEBAR_PANEL',
  AVATAR_LINK: 'AVATAR_LINK',
  MONTHS_WEEKS: 'MONTHS_WEEKS',
  IS_BANK_VIEW_CLICKED: 'IS_BANK_VIEW_CLICKED',
  SESSION_TIMER: 'SESSION_TIMER',
  TASKS_COUNT: 'TASKS_COUNT',
  IS_DISPLAY_BANKS_SECTION: 'IS_DISPLAY_BANKS_SECTION',
  IS_DISPLAY_ORDERS_SECTION: 'IS_DISPLAY_ORDERS_SECTION',
  CUSTOMER_TITLE: 'CUSTOMER_TITLE',
  PAGE_DROPDOWN_OPEN: 'PAGE_DROPDOWN_OPEN',
  SELECTED_DROPDOWN_VALUE: 'SELECTED_DROPDOWN_VALUE',
  IS_DISPLAY_COMMON_HEADER_SIDEMENU: 'IS_DISPLAY_COMMON_HEADER_SIDEMENU',
  IS_DISPLAY_FROM_CALENDAR: 'IS_DISPLAY_FROM_CALENDAR',
  IS_DISPLAY_TO_CALENDAR: 'IS_DISPLAY_TO_CALENDAR',
  CUSTOMER_STP: 'CUSTOMER_STP',
  TRANSLATIONS_GREATWORK: 'TRANSLATIONS_GREATWORK',
  IS_DISPLAY_BANK_VIEW_CATALOG: 'IS_DISPLAY_BANK_VIEW_CATALOG',
  REDEEM_PROGRAMS: 'REDEEM_PROGRAMS',
  MANUALLY_ENTERED_DATE: 'MANUALLY_ENTERED_DATE'
};
